export const animateProps = {
    initial:{opacity:0},
    animate:{ opacity: 1, transition: { delay: 0.05, duration: 0.5 } }
}